import { render, staticRenderFns } from "./GradingGuidelines.vue?vue&type=template&id=758776b6&"
import script from "./GradingGuidelines.vue?vue&type=script&lang=js&"
export * from "./GradingGuidelines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports